import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import axiosInterceptor from '../../utils/axios/axiosInterceptor';
import {
  FetchScriptResponse,
  ScriptData,
  Step,
} from '../../types/downloadScript';
import { projectRunBasePath } from '../../services/projectRunsApi';

const api = () => axiosInterceptor(true);

interface DownloadScriptState {
  saveSchemaDownloadScript: ScriptData | null;
  saveExportDataAndDeidentificationScript: ScriptData | null;
  exportQueryLogsScript: ScriptData | null;
}

const initialState: DownloadScriptState = {
  saveSchemaDownloadScript: null,   
  saveExportDataAndDeidentificationScript: null,
  exportQueryLogsScript: null,
};

export const fetchScript = createAsyncThunk(
  'downloadScript/fetchScript',
  async (
    payload: { projectID: number; runId: number | null; data: unknown; step: Step },
    { rejectWithValue }
  ) => {
    try {
      const base = projectRunBasePath(payload.projectID, payload.runId);
      if (!base) {
        return rejectWithValue({ error: 'No run selected' });
      }
      const response = await api().post(`${base}/fetch-scripts`, {
        step: payload.step,
        ...((payload.data as object) || {}),
      });
      return { ...response.data, step: payload.step };
    } catch (err) {
      return rejectWithValue({ error: (err as Error).message });
    }
  }
);

const downloadScriptSlice = createSlice({
  name: 'downloadScript',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      fetchScript.fulfilled,
      (state, action: PayloadAction<FetchScriptResponse>) => {
        const { step, url, expiry } = action.payload;
        if (step === Step.STEP_1B) {
          state.saveSchemaDownloadScript = { url, expiry };
        } else if (step === Step.STEP_4B) {
          state.saveExportDataAndDeidentificationScript = { url, expiry };
        } else if (step === Step.STEP_2A) {
          state.exportQueryLogsScript = { url, expiry };
        }
      }
    );
  },
});

export default downloadScriptSlice.reducer;
